module.exports = __webpack_public_path__ + "img/vip_xiangqing_yaoshi.244eb9df.png";